// extracted by mini-css-extract-plugin
export default {"experiencePage":"Experience_experiencePage__f1aR8","experienceContainer":"Experience_experienceContainer__7kJUz","educationContainer":"Experience_educationContainer__GmXnD"};